import { useState, useRef, useCallback } from "react";
import { useClickOutside } from "@/hooks/useClickOutside";

export const useDropdown = () => {
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	useClickOutside(ref, close, isOpen);

	const toggle = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	const open = useCallback(() => {
		setIsOpen(true);
	}, []);

	return {
		isOpen,
		toggle,
		open,
		close,
		ref,
	};
};
